import { connect } from 'react-redux'
import { setWizards, resetTradeInWizard } from 'core/components/wizard/actions'
import { setConfigurator } from '../actions'
import TradeIn from './TradeIn'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator,
  tradeInConfig: state.configuration.campaign.tradeInConfig
})

const mapDispatchToProps = {
  setWizards,
  resetTradeInWizard,
  setConfigurator
}

export default connect(mapStateToProps, mapDispatchToProps)(TradeIn)
